export enum LogEventMethod {
  DO = "do",
  UNDO = "undo",
  REDO = "redo"
}

export enum LogEventName {
  CREATE_TILE,
  COPY_TILE,
  MOVE_TILE,
  DELETE_TILE,
  RENAME_TILE,

  VIEW_SHOW_DOCUMENT,
  VIEW_SHOW_COMPARISON_DOCUMENT,
  VIEW_SHOW_TEACHER_NETWORK_COMPARISON_DOCUMENT,
  VIEW_SHOW_EXEMPLAR_DOCUMENT,
  VIEW_ENTER_FOUR_UP,
  VIEW_ENTER_ONE_UP,
  VIEW_FOUR_UP_RESIZED,
  VIEW_SHOW_COMPARISON_PANEL,
  VIEW_HIDE_COMPARISON_PANEL,
  VIEW_SHOW_SUPPORT,
  VIEW_GROUP,

  CREATE_PERSONAL_DOCUMENT,
  CREATE_LEARNING_LOG,

  SHOW_WORK,
  SHOW_TAB,
  SHOW_TAB_SECTION,
  HIDE_SOLUTIONS,
  SHOW_SOLUTIONS,

  GEOMETRY_TOOL_CHANGE,
  DRAWING_TOOL_CHANGE,
  TABLE_TOOL_CHANGE,
  TEXT_TOOL_CHANGE,
  DATAFLOW_TOOL_CHANGE,

  TILE_LINK,
  TILE_UNLINK,

  TILE_UNDO,
  TILE_REDO,

  PUBLISH_DOCUMENT,
  PUBLISH_SUPPORT,
  DELETE_SUPPORT,

  CREATE_STICKY_NOTE,
  CLOSE_STICKY_NOTES,
  OPEN_STICKY_NOTES,

  ADD_INITIAL_COMMENT_FOR_DOCUMENT,
  ADD_INITIAL_COMMENT_FOR_TILE,
  ADD_RESPONSE_COMMENT_FOR_DOCUMENT,
  ADD_RESPONSE_COMMENT_FOR_TILE,
  DELETE_COMMENT_FOR_DOCUMENT,
  DELETE_COMMENT_FOR_TILE,
  EXPAND_COMMENT_THREAD_FOR_DOCUMENT,
  EXPAND_COMMENT_THREAD_FOR_TILE,
  COLLAPSE_COMMENT_THREAD_FOR_DOCUMENT,
  COLLAPSE_COMMENT_THREAD_FOR_TILE,
  CHAT_PANEL_HIDE,
  CHAT_PANEL_SHOW,

  // the following are for potential debugging purposes and are all marked "internal"
  INTERNAL_AUTHENTICATED,
  INTERNAL_ERROR_ENCOUNTERED,
  INTERNAL_TEST_EVENT,

  DASHBOARD_SWITCH_CLASS,
  DASHBOARD_SWITCH_PROBLEM,
  DASHBOARD_DESELECT_STUDENT,
  DASHBOARD_SELECT_STUDENT,
  DASHBOARD_TOGGLE_TO_WORKSPACE,
  DASHBOARD_TOGGLE_TO_DASHBOARD,

  TEACHER_NETWORK_EXPAND_DOCUMENT_SECTION,
  TEACHER_NETWORK_COLLAPSE_DOCUMENT_SECTION,

  HISTORY_SHOW_CONTROLS,
  HISTORY_HIDE_CONTROLS,
  HISTORY_PLAYBACK_START,
  HISTORY_PLAYBACK_STOP,
  HISTORY_PLAYBACK_SEEK,

  SPARROW_CREATION,
  SPARROW_DELETION,
  SPARROW_TITLE_CHANGE,
  SPARROW_SHOW_HIDE,

  LOADING_MEASUREMENTS,

  EXEMPLAR_VISIBILITY_UPDATE
}
